<template>
  <v-dialog v-model="show" max-width="300px" persistent>
    <!-- alerta -->
    <v-snackbar top v-model="snackbar" :color="snackbarColor" multi-line>
      {{ snackbarText }}
      <v-btn dark icon text @click="snackbar = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-card class="pa-4 pt-5">
      <v-btn class="float" icon @click="$emit('close')">
        <v-icon>close</v-icon>
      </v-btn>
      <v-layout column align-center justify-center text-center v-if="!ifPhone">
        <span class="title">Verifique seu número</span>
        <span class="sudheading pt-4 font-weight-medium"
          >Insira um número de telefone válido para receber o código de
          verificação</span
        >
        <v-layout class="pt-3">
          <v-text-field
            key="number-input"
            class="mx-5 centered-input"
            v-mask="'(##)#####-####'"
            v-model="newNumber"
            :rules="[rules.required]"
          ></v-text-field>
        </v-layout>
        <v-btn
          class="w-100 btn-sucess white--text mt-4"
          @click="sendSmsNewNumber()"
          >Solicitar SMS</v-btn
        >
      </v-layout>
      <v-layout column align-center justify-center text-center v-if="ifPhone">
        <span class="title">Insira o código</span>
        <span class="sudheading pt-4 font-weight-medium"
          >Por favor insira o código que enviamos para {{ user.phone }}</span
        >
        <v-layout class="pt-3">
          <v-text-field
            key="hash-input"
            counter="4"
            maxlength="4"
            :rules="[rules.required]"
            class="mx-5"
            v-model="verifyCode"
          ></v-text-field>
        </v-layout>
        <v-btn
          class="w-100 btn-sucess white--text mt-4"
          :disabled="desabilitarBtnVerificarNumero"
          @click="verifyNumber()"
          >Verificar</v-btn
        >
        <v-layout column class="pt-3">
          <v-btn text small class="ma-0" @click="sendSms()">Reenviar SMS</v-btn>
          <v-btn text small class="ma-0" @click="ifPhone = false"
            >Mudar meu número</v-btn
          >
        </v-layout>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import UserController from '../../controllers/UserController';

export default {
  async created() {
    await this.getUser();
    this.verifyData();
  },

  data() {
    return {
      desabilitarBtnVerificarNumero: false,
      ifPhone: false,
      verifyCode: null,
      upperVerifyCode: '',
      userController: new UserController(this.$resource),
      newNumber: null,
      rules: {
        required: value => !!value || 'Campo Obrigatório',
      },
      snackbar: false,
      snackbarColor: '',
      snackbarText: '',
    };
  },

  props: {
    show: Boolean,
  },

  methods: {
    async getUser() {
      if (!localStorage.getItem('verify_number'))
        localStorage.setItem('verify_number', 0);

      await this.userController
        .getUserData()
        .then(res => {
          this.user = res.user;
        })
        .catch(error => {
          console.log(error);
        });
    },

    validatePhoneNumber(phoneNumber) {
      const regex = /\b\d{2}[-.]?\d{5}[-.]?\d{4}\b/;
      if (regex.test(phoneNumber)) {
        return true;
      }
      return false;
    },

    verifyData() {
      if (this.user.phone) {
        if (
          localStorage.getItem('verify_number') == 0 ||
          this.$route.name == 'usr-profile'
        ) {
          this.sendSms();
          localStorage.setItem('verify_number', 1);
        }
        this.ifPhone = true;
      } else this.ifPhone = false;
    },

    async sendSms() {
      await this.userController
        .sendSms()
        .then(res => {
          this.snackbarColor = 'success';
          this.snackbarText = res.message;
          this.snackbar = true;
        })
        .catch(e => {
          this.snackbarColor = 'error';
          this.snackbarText = e.message;
          this.snackbar = true;
        });
    },

    async sendSmsNewNumber() {
      let formatedNumber = this.newNumber
        .replace('(', '')
        .replace(')', '')
        .replace('-', '');
      if (this.validatePhoneNumber(formatedNumber)) {
        await this.userController
          .changeNumberAndHashAndSendSms(formatedNumber)
          .then(async res => {
            await this.getUser();
            this.ifPhone = true;
          })
          .catch(e => {
            this.snackbarColor = 'error';
            this.snackbarText = e.message;
            this.snackbar = true;
          });
      }
    },

    verifyNumber() {
      try {
        this.desabilitarBtnVerificarNumero = true;
        this.upperVerifyCode = this.verifyCode.toUpperCase();
        if (this.user.hash_sms === this.upperVerifyCode) {
          this.user.confirmed_sms = true;
          this.userController
            .partialUpdate(this.user)
            .then(res => {
              console.log(res);
              this.snackbarColor = 'success';
              this.snackbarText = 'Número verificado!';
              this.snackbar = true;
              setTimeout(() => {
                this.$emit('closeModal');
                this.desabilitarBtnVerificarNumero = false;
              }, 2000);
            })
            .catch(e => {
              console.log(e);
              this.desabilitarBtnVerificarNumero = false;
            });
        } else {
          this.snackbarColor = 'error';
          this.snackbarText = 'Código inválido';
          this.snackbar = true;
          this.desabilitarBtnVerificarNumero = false;
        }
      } catch (err) {
        console.log(err, 'erro');
        this.desabilitarBtnVerificarNumero = false;
      }
    },
  },
};
</script>

<style scoped>
.float {
  position: absolute;
  top: 5px;
  right: 5px;
}
.centered-input >>> input {
  text-align: center;
  font-size: 20px;
  font-weight: 500;
}
</style>
